<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-2">
        <div class="modal-title" i18n>BDC Listing</div>
        <app-page-help articleId="5nVxEefDgZ4kkBJk6Edb6m" videoId="-"></app-page-help>
      </div>
      <a (click)="close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>

    <ul class="nav top-navbar bg-white border-bottom" role="tablist">
      <li [class.active]="tab$.value === tabs.Details">
        <a (click)="tab$.next(tabs.Details)" i18n> Review Rental Details </a>
      </li>
      <li [class.active]="tab$.value === tabs.Contacts">
        <a (click)="tab$.next(tabs.Contacts)" i18n> Contacts </a>
      </li>
      <li [class.active]="tab$.value === tabs.Amenities">
        <a (click)="tab$.next(tabs.Amenities)" i18n> Amenities </a>
      </li>
      <li [class.active]="tab$.value === tabs.Settings">
        <a (click)="tab$.next(tabs.Settings)" i18n> Settings & Policy </a>
      </li>
      <li [class.active]="tab$.value === tabs.Licenses">
        <a (click)="tab$.next(tabs.Licenses)" i18n> Licenses </a>
      </li>
      <li [class.active]="tab$.value === tabs.Gallery">
        <a (click)="tab$.next(tabs.Gallery)" i18n> Gallery </a>
      </li>
    </ul>

    <ul class="nav drawer-right-navbar">
      <li
        [class.active]="tab$.value === tabs.Photos"
        i18n-matTooltip
        matTooltip="All Property Photos"
        matTooltipPosition="left"
      >
        <a (click)="tab$.next(tabs.Photos)">
          <i class="far fa-images"></i>
        </a>
      </li>
      <li [class.active]="tab$.value === tabs.Units" i18n-matTooltip matTooltip="Units" matTooltipPosition="left">
        <a (click)="tab$.next(tabs.Units)">
          <i class="cs-icon cs-icon-buildings"></i>
        </a>
      </li>
      <li [class.active]="tab$.value === tabs.Products" i18n-matTooltip matTooltip="Products" matTooltipPosition="left">
        <a (click)="tab$.next(tabs.Products)">
          <i class="fal fa-hand-holding-usd"></i>
        </a>
      </li>
      <li [class.active]="tab$.value === tabs.Rates" i18n-matTooltip matTooltip="Rates" matTooltipPosition="left">
        <a (click)="tab$.next(tabs.Rates)">
          <i class="cs-icon cs-icon-calendar-dollar-circle"></i>
        </a>
      </li>
    </ul>

    <div class="modal-body">
      <div class="alert alert-danger" *ngIf="property?.isAccountFraudSuspected">
        <i class="far fa-exclamation-triangle alert-icon"></i>
        <ng-container i18n
          >This Account is suspected of fraudulent activity. Please contact Booking.com support.</ng-container
        >
        <ng-container *ngIf="property?.fraud_suspected_property_ids?.length" i18n>
          Flagged Booking.com property ID(s): {{ property?.fraud_suspected_property_ids?.join(', ') }}</ng-container
        >
      </div>

      <div class="alert alert-danger" *ngIf="property?.isPropertyFraudSuspected && !property?.isAccountFraudSuspected">
        <i class="far fa-exclamation-triangle alert-icon"></i>
        <ng-container i18n
          >This property is suspected of fraudulent activity. Please contact Booking.com support.</ng-container
        >
      </div>

      <ng-container [ngSwitch]="tab$.value">
        <app-bdc-property-details
          *ngSwitchCase="tabs.Details"
          [propertyId]="connection.propertyId"
          [property]="property"
          (propertyChange)="property = $event"
          [isLoading]="isLoading"
        ></app-bdc-property-details>
        <app-bdc-property-contacts
          *ngSwitchCase="tabs.Contacts"
          [propertyId]="connection.propertyId"
        ></app-bdc-property-contacts>
        <app-bdc-property-amenities
          *ngSwitchCase="tabs.Amenities"
          [propertyId]="connection.propertyId"
        ></app-bdc-property-amenities>
        <app-bdc-property-settings
          *ngSwitchCase="tabs.Settings"
          [propertyId]="connection.propertyId"
          [property]="property"
        ></app-bdc-property-settings>
        <app-bdc-property-licenses
          *ngSwitchCase="tabs.Licenses"
          [propertyId]="connection.propertyId"
        ></app-bdc-property-licenses>
        <app-bdc-property-photos
          *ngSwitchCase="tabs.Photos"
          [propertyId]="connection.propertyId"
          [isFraud]="isFraud"
        ></app-bdc-property-photos>
        <app-bdc-property-photos-gallery
          *ngSwitchCase="tabs.Gallery"
          [propertyId]="connection.propertyId"
        ></app-bdc-property-photos-gallery>
        <app-bdc-property-units
          *ngSwitchCase="tabs.Units"
          [propertyId]="connection.propertyId"
        ></app-bdc-property-units>
        <app-bdc-property-products
          *ngSwitchCase="tabs.Products"
          [propertyId]="connection.propertyId"
        ></app-bdc-property-products>
        <app-bdc-property-rates
          *ngSwitchCase="tabs.Rates"
          [propertyId]="connection.propertyId"
        ></app-bdc-property-rates>
      </ng-container>
    </div>
  </div>
</div>
